import * as amplitude from "@amplitude/analytics-browser";
import { Identify } from "@amplitude/analytics-browser";
import { isReferralLink } from "./referral";

const STORAGE_KEY = "bws_share";
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
const SHARE_ID_PATTERN = /^[0-9a-z]{12}$/;

function clearShare() {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* Storage can be disabled. */ }
}

export function getStoredShareId(): string | undefined {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (value && typeof value.shareId === "string" && SHARE_ID_PATTERN.test(value.shareId) &&
        typeof value.savedAt === "number" && Number.isFinite(value.savedAt) &&
        value.savedAt <= Date.now() && Date.now() - value.savedAt < MAX_AGE) {
      return value.shareId;
    }
  } catch { /* Invalid or inaccessible storage fails closed. */ }
  clearShare();
  return undefined;
}

let landed = false;

// A member's shared link carries `s` (the share id). Read it once per document
// landing; a reload of the same link updates savedAt without a second event.
export function captureShareLink() {
  if (landed) return;
  landed = true;
  const params = new URLSearchParams(window.location.search);
  const values = params.getAll("s");
  const shareId = values.length === 1 && SHARE_ID_PATTERN.test(values[0]) ? values[0] : undefined;
  if (!shareId) {
    // A referral link without an id replaces an older shared link's id.
    if (isReferralLink(window.location.search)) clearShare();
    return;
  }

  const isNewShare = getStoredShareId() !== shareId;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ shareId, savedAt: Date.now() }));
  } catch { /* Storage can be disabled; the open is still recorded. */ }
  if (!isNewShare) return;

  // Calls before amplitude.init (App.tsx) are queued by the SDK.
  amplitude.track("shared_link_opened", {
    share_id: shareId,
    link_type: isReferralLink(window.location.search) ? "referral" : "unknown",
    receiver: "quiz",
  });
  const identify = new Identify();
  identify.set("share_id", shareId);
  amplitude.identify(identify);
}
